'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.System = void 0;
var tslib_1 = require("tslib");
var index_js_1 = require("../../shared/index.js");
var index_js_2 = require("../../shared/sources/index.js");
var System = /** @class */ (function (_super) {
    tslib_1.__extends(System, _super);
    function System(setupConfigParams) {
        var settings = [];
        // TODO: ES Modules
        if (document.currentScript) {
            var attrsParams = getParametersFromAttributes(document.currentScript);
            var urlParams = getParametersFromSrc(document.currentScript);
            var projectName = (0, index_js_1.mkSetting)({
                key: index_js_1.SYSTEM_KEYS.projectName,
                value: (setupConfigParams === null || setupConfigParams === void 0 ? void 0 : setupConfigParams.settingsKey) ||
                    attrsParams.projectName ||
                    (urlParams === null || urlParams === void 0 ? void 0 : urlParams.projectName) ||
                    (setupConfigParams === null || setupConfigParams === void 0 ? void 0 : setupConfigParams.projectName),
                priority: 10000,
            });
            var requestIdRaw = attrsParams.requestId || (urlParams === null || urlParams === void 0 ? void 0 : urlParams.requestId) || (setupConfigParams === null || setupConfigParams === void 0 ? void 0 : setupConfigParams.requestId);
            var requestId = (0, index_js_1.mkSetting)({
                key: index_js_1.SYSTEM_KEYS.requestId,
                // INFO: Идентификатор запроса может быть числом и `mkSetting` может его сконвертировать в int
                value: requestIdRaw && "\"".concat(requestIdRaw, "\""),
                priority: 10000,
            });
            var versionCommitRaw = attrsParams.versionCommit || (urlParams === null || urlParams === void 0 ? void 0 : urlParams.versionCommit);
            var versionCommit = (0, index_js_1.mkSetting)({
                key: index_js_1.SYSTEM_KEYS.versionCommit,
                // INFO: Хеш коммита может быть числом и `mkSetting` может его сконвертировать в int
                value: versionCommitRaw && "\"".concat(versionCommitRaw, "\""),
                priority: 10000,
            });
            if (projectName === null || projectName === void 0 ? void 0 : projectName.value) {
                settings.push(projectName);
            }
            if (requestId === null || requestId === void 0 ? void 0 : requestId.value) {
                settings.push(requestId);
            }
            if (versionCommit === null || versionCommit === void 0 ? void 0 : versionCommit.value) {
                settings.push(versionCommit);
            }
        }
        return _super.call(this, settings) || this;
    }
    return System;
}(index_js_2.SortedSource));
exports.System = System;
function getParametersFromAttributes(scriptEl) {
    var projectName = scriptEl.dataset[index_js_1.SYSTEM_KEYS_ATTR_MAP.projectName];
    var requestId = scriptEl.dataset[index_js_1.SYSTEM_KEYS_ATTR_MAP.requestId];
    var versionCommit = scriptEl.dataset[index_js_1.SYSTEM_KEYS_ATTR_MAP.versionCommit];
    return { projectName: projectName, requestId: requestId, versionCommit: versionCommit };
}
function getParametersFromSrc(scriptEl) {
    var src = scriptEl.getAttribute('src');
    if (!src) {
        return null;
    }
    var searchParams = new URL(src, window.location.origin).searchParams;
    var projectName = searchParams.get(index_js_1.SYSTEM_KEYS_QUERY_MAP.projectName);
    var requestId = searchParams.get(index_js_1.SYSTEM_KEYS_QUERY_MAP.requestId);
    var versionCommit = searchParams.get(index_js_1.SYSTEM_KEYS_QUERY_MAP.versionCommit);
    return { projectName: projectName, requestId: requestId, versionCommit: versionCommit };
}
//# sourceMappingURL=system.js.map
